import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import Box from "@mui/material/Box";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import Pagination from "../../Pagination/Pagination";
import { useAppContext } from "../../Lib/ContextLib";
import { API_URL } from "../../config";
import Loader from "../Loader/Loader";
import EmptyState from "../../Components/EmptyState";

export default function RoomTier() {
  const { showPage, setShowPage, accessObject } = useAppContext();
  const [alert, setAlert] = React.useState(null);
  const [tableData, setTableData] = React.useState([]);
  const [rowValue, setRowValue] = React.useState();
  const [openValue, setOpenValue] = React.useState(0);
  const [loader, setLoader] = React.useState(false);
  const [showPrePage] = React.useState(10);
  const [buttonLoader, setbuttonLoader] = React.useState(false);
  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  const updateShowPerpagevalue = (value) => {
    // setShowPrePage(value);
    // setPagination({ start: 0, end: value });
  };

  const LoginSchema = Yup.object().shape({
    amount: Yup.string().required("required"),
    adminCommission: Yup.string().required("required"),
  });

  React.useEffect(() => {
    getBranch();
  }, []);

  const getBranch = () => {
    setLoader(true);
    axios(`${API_URL}/api/admin/room-tier/get-room-tier`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        setLoader(false);

        setTableData(response.data.data);
      })
      .catch((error) => {
        console.log("getBranch error :::", error);
      });
  };

  const clickEditButton = (item) => {
    setShowPage(true);
    setRowValue(item);
    setOpenValue(2);
  };

  const openAddTournament = (value) => {
    setRowValue();
    console.log("openAddTournament :::", value);
    setShowPage(true);
    setOpenValue(value);
  };

  const updateTournament = (value) => {
    console.log("updateTournament value :::", value);

    axios
      .patch(
        `${API_URL}/api/admin/room-tier/update-room-tier/${rowValue._id}`,
        value
      )
      .then((res) => {
        console.log("updateTournament update :::", res.data);
        if (res.data.status) {
          successEdit(res.data.message);
          setbuttonLoader(false);
        } else {
          warningAlert();
          setbuttonLoader(false);
        }
      })
      .catch((err) => {
        setbuttonLoader(false);
        console.log("updateTournament err :::", err);
        warningAlert();
      });
  };

  const addNewTournament = (value) => {
    console.log("addNewTournament ---", value);

    axios(`${API_URL}/api/admin/room-tier/add-room-tier`, {
      method: "POST",
      credentials: "include",
      data: value,
    })
      .then((result) => {
        console.log("addNewTournament result :::", result.data);
        if (result.data.status) {
          setbuttonLoader(false);
          successAdd();
        } else {
          warningAlert();
          setbuttonLoader(false);
        }
      })
      .catch((err) => {
        console.log("addNewTournament err :::", err);
        warningAlert();
      });
  };

  const warningWithConfirmMessage = (e) => {
    setAlert(
      <SweetAlert
        custom
        showCancel
        confirmBtnText="Yes, Delete"
        cancelBtnText="Cancel"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        onConfirm={() => {
          deleteData(e);
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm bg-danger shadow-danger"
        cancelBtnClass="premium-alert-cancel"
        customIcon={<div className="mb-4" style={{ fontSize: '50px', color: '#dc3545' }}><i className="fas fa-trash-alt"></i></div>}
      >
        <div className="premium-alert-title">Are you sure?</div>
        <p className="premium-alert-text">You are about to delete this room tier. This action cannot be undone.</p>
      </SweetAlert>
    );
  };

  const successDeleted = () => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Deleted!</div>
        <p className="premium-alert-text">The room tier record has been successfully removed.</p>
      </SweetAlert>
    );
  };

  const deleteData = (e) => {
    console.log("e===>", e._id);
    axios
      .delete(`${API_URL}/api/admin/room-tier/delete-room-tier/${e._id}`)
      .then((res) => {
        console.log(res);
        console.log(res.data);
        getBranch();
      });
  };

  const successAdd = () => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Success!</div>
        <p className="premium-alert-text">The room tier record has been added successfully.</p>
      </SweetAlert>
    );
  };

  const successEdit = (msg) => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Updated!</div>
        <p className="premium-alert-text">{msg || "The room tier record has been updated successfully."}</p>
      </SweetAlert>
    );
  };

  const warningAlert = () => {
    setAlert(
      <SweetAlert
        warning
        onConfirm={() => setAlert(null)}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Wait!</div>
        <p className="premium-alert-text">Something went wrong. Please try again later.</p>
      </SweetAlert>
    );
  };

  return (
    <>
      {alert}
      {showPage ? (
        <div class="content p-3 ">
          <div className="card p-3">
            <Box sx={{ width: "100%" }}>
              <Formik
                initialValues={{
                  amount: rowValue ? rowValue?.amount : "",
                  adminCommission: rowValue ? rowValue?.adminCommission : "",
                }}
                validationSchema={LoginSchema}
                onSubmit={(values) => {
                  setbuttonLoader(true);
                  console.log(values);

                  if (openValue === 1) {
                    console.log("update formik value :::", openValue);
                    addNewTournament(values);
                  }
                  if (openValue === 2) {
                    console.log("update formik value :::", openValue);
                    updateTournament(values);
                  }
                }}
              >
                {({ touched, errors, isSubmitting, values, setFieldValue }) => (
                  <div>
                    <Form>
                      <div className="form-group">
                        <label htmlFor="password" className="mt-3">
                          Amount
                        </label>
                        <Field
                          type="number"
                          name="amount"
                          placeholder="Enter Amount..."
                          className={`mt-2 form-control
                          ${touched.amount && errors.amount ? "is-invalid" : ""
                            }`}
                        />
                        <ErrorMessage
                          component="div"
                          name="amount"
                          className="invalid-feedback"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="password" className="mt-3">
                          Admin Comission
                        </label>
                        <Field
                          type="number"
                          name="adminCommission"
                          placeholder="Enter Admin Comission..."
                          className={`mt-2 form-control
                          ${touched.adminCommission && errors.adminCommission
                              ? "is-invalid"
                              : ""
                            }`}
                        />
                        <ErrorMessage
                          component="div"
                          name="adminCommission"
                          className="invalid-feedback"
                        />
                      </div>
                      <button
                        style={{ width: "100px" }}
                        type="submit"
                        className="btn btn-primary btn-block mt-4 mr-2"
                        disabled={buttonLoader}
                      >
                        <div
                          className="d-flex"
                          style={{
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <div
                            className="d-flex"
                            style={{
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <b>Submit</b>
                          </div>
                          {buttonLoader && (
                            <div>
                              <div
                                class="spinner-border ml-2 mt-1"
                                role="status"
                                style={{ height: "20px", width: "20px" }}
                              ></div>
                            </div>
                          )}
                        </div>
                      </button>
                    </Form>
                  </div>
                )}
              </Formik>
            </Box>
          </div>
        </div>
      ) : (
        <div className="content p-3">
          <div class="card ">
            {/* <div
              class="pl-4 pr-4 pt-4"
              style={{ display: "flex", justifyContent: "space-between" }}
                          > */}
            <div className="row pl-4 pr-4 pt-4">
              <div className="col-12 col-md-5">
                {accessObject?.addRoomTier === true && (
                  <button
                    style={{ width: "118px" }}
                    onClick={() => {
                      openAddTournament(1);
                    }}
                    type="button"
                    className="btn btn-primary btn-block "
                  >
                    <AddIcon />
                    Add New
                  </button>
                )}
              </div>
              <div className="col-12 col-md-7">
                <h3 class="card-title">
                  <b>Room Tier</b>
                </h3>
              </div>
            </div>

            <div class="card-body">
              <table id="" class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>SrNo</th>
                    <th>Amount</th>
                    <th>Admin Comission</th>
                    {(accessObject?.editRoomTier === true ||
                      accessObject?.deleteRoomTier === true) && (
                        <th style={{ textAlign: "center" }}>Action</th>
                      )}
                  </tr>
                </thead>
                {accessObject?.getRoomTier === true ? (
                  <tbody>
                    {!loader ? (
                      <>
                        {tableData.length > 0 ? (
                          <>
                            {tableData
                              ?.slice(pagination.start, pagination.end)
                              .map((item, index) => (
                                <>
                                  <tr key={index}>
                                    <td>{index + 1 + pagination.start}</td>
                                    <td>{item.amount}</td>
                                    <td>{item.adminCommission}</td>
                                    {(accessObject?.editRoomTier === true ||
                                      accessObject?.deleteRoomTier ===
                                      true) && (
                                        <td className="justify-content-evenly ">
                                          <div className="d-flex">
                                            {accessObject?.editRoomTier ===
                                              true && (
                                                <EditIcon
                                                  className="mr-3 courser"
                                                  onClick={() =>
                                                    clickEditButton(item)
                                                  }
                                                />
                                              )}
                                            {/* {accessObject?.deleteRoomTier ===
                                            true && (
                                            <ClearIcon
                                              className="courser text-danger"
                                              onClick={() =>
                                                warningWithConfirmMessage(item)
                                              }
                                            />
                                          )} */}
                                          </div>
                                        </td>
                                      )}
                                  </tr>
                                </>
                              ))}
                          </>
                        ) : (
                          <EmptyState colSpan={6} />
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </tbody>
                ) : (
                  <>
                    <tr
                      style={{ backgroundColor: "rgba(0,0,0,.05)" }}
                      className="text-center"
                    >
                      <td colSpan={6}>
                        <h5>Access Denied</h5>
                      </td>
                    </tr>
                  </>
                )}
              </table>
              <div className="mt-4">{loader && <Loader />}</div>
            </div>
            {tableData.length !== 0 && (
              <Pagination
                updateShowPerpagevalue={updateShowPerpagevalue}
                showPrePage={showPrePage}
                onPaginationChange={onPaginationChange}
                total={tableData.length}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
}
